var React = require('react');

function SingleStarInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.501251 7.92882C4.63643 7.41321 7.91396 4.13551 8.42974 0H8.57126C9.08701 4.13534 12.3643 7.41294 16.4992 7.92875V8.0703C12.364 8.58615 9.08651 11.8642 8.57114 16H8.42985C7.91446 11.864 4.63675 8.58588 0.501251 8.07024L0.501251 7.92882Z","fill":"#131416"}));
}

SingleStarInline.defaultProps = {"width":"17","height":"16","viewBox":"0 0 17 16","fill":"none"};

module.exports = SingleStarInline;

SingleStarInline.default = SingleStarInline;
